import { render, staticRenderFns } from "./consultStandardPopup.vue?vue&type=template&id=c6f8cf28&scoped=true&"
import script from "./consultStandardPopup.vue?vue&type=script&lang=js&"
export * from "./consultStandardPopup.vue?vue&type=script&lang=js&"
import style0 from "./consultStandardPopup.vue?vue&type=style&index=0&id=c6f8cf28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f8cf28",
  null
  
)

export default component.exports